<template>
  <div class="com-container relative">
    <div class="main-box">
      <div class="relative">
        <div class="top-title">
          <!-- <img
            src="../assets/images/index/title.png"
            alt
            class="top-title"
            width="400"
            height="50"
          />-->
        </div>

        <div class="swiper-box">
          <div class="recommendPage swiper-no-swiping">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in listData" :key="index">
                <div class="s-item">
                  <div
                    class="course-box"
                    v-for="(item2, index2) in item"
                    :key="index2"
                  >
                    <router-link
                      :to="
                        '/list/' + item2.kecheng_id + '/' + item2.kecheng_type
                      "
                    >
                      <img
                        :src="'http://www.ezhidao.net' + item2.kecheng_img"
                        alt
                        width="100%"
                      />
                      <img
                        src="../assets/images/index/btn.png"
                        class="btn-status"
                        v-if="item2.kecheng_type == '正式'"
                      />
                      <img
                        src="../assets/images/index/shiyong.png"
                        class="btn-status"
                        v-else
                      />
                    </router-link>
                  </div>
                </div>
              </swiper-slide>

              <div
                v-show="listData.length > 1"
                class="swiper-pagination"
                slot="pagination"
              ></div>
            </swiper>
            <div v-show="listData.length > 1">
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!-- relavive end -->
    </div>
    <!-- main-box end -->
    <!-- 底部 -->
    <Footer :webName="webName"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src

/* eslint-disable */
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Footer from "@/components/Footer.vue";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    Footer,
  },
  data() {
    return {
      webName: "首页",
      listData: [],
      swiperOption: {
        loop: false,
        // slidesPerView: 4, //slide可见数量
        // spaceBetween: 0, //slide之间的距离（单位px）

        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。默认为true：
        // },

        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          //分页
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            //自定义分页的按钮
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
        on:{
           slideChange:function(){
              localStorage.setItem("page",this.activeIndex);
              console.log(localStorage.getItem("page"),"okok?");
            }
        },
        initialSlide: localStorage.getItem("page")%10,
      },
    };
    console.log(localStorage.getItem("page"),"初始")
  },
  mounted() {
    this.swiperOption.initialSlide = 0;
    if(!localStorage.getItem("page")){
      localStorage.setItem("page",this.swiperOption.initialSlide);
    }
    var that = this;
    // 登录判定
    if (this.getCookie("account_id")) {
      this.setCookie("account_id", this.getCookie("account_id"), 120);
    } else {
      this.$message({
        message: "请先登录",
        type: "warning",
        duration: 1000,
        onClose: function () {
          that.$router.push({ path: "/" });
        },
      });
    }

    this.$axios({
      method: "GET",
      url: this.apiTp5Url + "/getOrgInfo",
      params: {
        account_id: this.getCookie("account_id"),
      },
    })
      .then((response) => {
        //console.log("返回:" + JSON.stringify(response.data));
        this.listData = response.data.accountKechengList;

        var chunk = 4;
        var len = response.data.accountKechengList.length;

        var result = [];
        for (let i = 0; i < len; i += chunk) {
          result.push(response.data.accountKechengList.slice(i, i + chunk)); // 每10项分成一组
        }

        this.listData = result;
        console.log(result);

        //课程信息
        localStorage.setItem(
          "accountKechengList",
          JSON.stringify(response.data.accountKechengList1)
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>
<style scoped>
.main-box {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.com-container {
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/images/list/bg.jpg") no-repeat center top;
  background-size: 100% 100%;
}
.top-title {
  text-align: center;
  padding: 10px;
}
/* 轮播图 */
.swiper-box {
  margin: 100px 200px;
}
.recommendPage {
  position: relative;
  height: 600px;
}
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 600px;
}

.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  color: #000;
  font-size: 16px;
  text-align: center;
}
.recommendPage .swiper-container .swiper-slide .s-item {
  margin: 8.5% auto;
  text-align: center;
  height: 80%;
}
.s-item .btn-status {
  width: 120px;
  margin-top: -200px;
  display: inline-block;
  z-index: 9999;
}
.s-item .course-box {
  width: 21.5%;
  float: left;
  margin-left: 3%;
  /*  float: left;
  text-align: center;
  margin-left: 80px;
  margin-top: 30px;*/
  position: relative;
  height: 33%;
}
/* 左右箭头 */
.swiper-button-prev {
  left: -50px;
  background: url("../assets/images/index/left.png") no-repeat center top;
  background-size: 50px;
  width: 60px;
  height: 60px;
  outline: none;
}
.swiper-button-next {
  right: -50px;
  background: url("../assets/images/index/right.png") no-repeat center top;
  background-size: 50px;
  width: 60px;
  height: 60px;
  outline: none;
}
/* 分页按钮 */
.swiper-pagination-bullet-custom {
  width: 9px;
  height: 9px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #000;
  opacity: 0.5;
  border-radius: 5px;
  background: #fff;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  color: #fff;
  background: #a11703;
}
</style>
<style >
/* 分页按钮 */
.swiper-pagination-bullet-custom {
  width: 20px;
  height: 20px;
  border-radius: 100px;
  background: #fff;
  border: 7px solid #f041e8;
  outline: none;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  color: #fff;
  background: #79c2d1;
}
.swiper-pagination-bullet-custom:hover {
  background: #79c2d1;
}
</style>
